import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let FacebookPixelMixin = class FacebookPixelMixin extends Vue {
    /**
     * Facebook Pixel Event Tracker Mixin
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.25.0}
     *
     * Reference: https://www.npmjs.com/package/vue-analytics-facebook-pixel#usage
     */
    fbPixelEventTracker(event, content = {}) {
        Vue.prototype.$analytics.fbq.event(event, content);
    }
};
FacebookPixelMixin = __decorate([
    Component
], FacebookPixelMixin);
export default FacebookPixelMixin;
